import React from 'react'
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { device } from 'utils/media';
import RippleStyled from 'components/Buttons/Ripple';

const RippleButton = styled(RippleStyled)`
    display: none;

    @media ${device.laptop} {
        display:block;
        width: 40px;
        height: 40px;
        background: #ff7107;
    }
`;

const IconSVG = styled.svg`
    height: 24px;
    width: 24px;
`;

const Shape = styled.path`
    fill: ${({theme:{buttons:{ripple}}}) => (ripple.shape)};
    transition: fill 300ms 100ms;
`;

const SVG = {
    OUTLINE:{
        PATH: `M428.756,300.104c-0.664-3.81-2.334-7.047-4.996-9.713c-5.9-5.903-12.752-7.142-20.554-3.716
        c-20.937,9.708-42.641,14.558-65.097,14.558c-28.171,0-54.152-6.94-77.943-20.838c-23.791-13.894-42.631-32.736-56.525-56.53
        c-13.899-23.793-20.844-49.773-20.844-77.945c0-21.888,4.333-42.683,12.991-62.384c8.66-19.7,21.176-36.973,37.543-51.82
        c6.283-5.898,7.713-12.752,4.287-20.557c-3.236-7.801-9.041-11.511-17.415-11.132c-29.121,1.141-56.72,7.664-82.797,19.556
        C111.33,31.478,88.917,47.13,70.168,66.548c-18.747,19.414-33.595,42.399-44.54,68.95c-10.942,26.553-16.416,54.39-16.416,83.511
        c0,29.694,5.806,58.054,17.416,85.082c11.613,27.028,27.218,50.344,46.824,69.949c19.604,19.599,42.92,35.207,69.951,46.822
        c27.028,11.607,55.384,17.415,85.075,17.415c42.64,0,81.987-11.563,118.054-34.69c36.069-23.124,63.05-54.006,80.944-92.645
        C429,307.519,429.427,303.906,428.756,300.104z M306.565,384.168c-24.646,11.711-50.676,17.562-78.087,17.562
        c-24.743,0-48.39-4.853-70.947-14.558c-22.554-9.705-41.971-22.695-58.246-38.972c-16.271-16.272-29.259-35.686-38.97-58.241
        c-9.707-22.556-14.561-46.203-14.561-70.948c0-40.922,12.135-77.466,36.403-109.636c24.266-32.165,55.531-53.959,93.788-65.379
        c-19.795,31.405-29.694,65.379-29.694,101.926c0,34.644,8.564,66.715,25.697,96.223c17.128,29.499,40.446,52.811,69.95,69.948
        c29.499,17.129,61.565,25.694,96.211,25.694c10.656,0,21.129-0.855,31.408-2.57C352.199,356.155,331.21,372.472,306.565,384.168z`,
        VIEW: `0 0 438.277 438.277`,
    },
    FILL:{
        PATH: `M459.782,347.328c-4.288-5.28-11.488-7.232-17.824-4.96c-17.76,6.368-37.024,9.632-57.312,9.632
        c-97.056,0-176-78.976-176-176c0-58.4,28.832-112.768,77.12-145.472c5.472-3.712,8.096-10.4,6.624-16.832
        S285.638,2.4,279.078,1.44C271.59,0.352,264.134,0,256.646,0c-132.352,0-240,107.648-240,240s107.648,240,240,240
        c84,0,160.416-42.688,204.352-114.176C464.55,360.032,464.038,352.64,459.782,347.328z`,
        VIEW: `0 0 480 480`,
    }

};

const Button = ({ buttonThemeChange, theme}) => (
    <RippleButton onClick={e =>buttonThemeChange(e, theme.NAME)} >
        <IconSVG version="1.1"  xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink"  
            viewBox={theme.NAME === 'LIGHT' ? SVG.OUTLINE.VIEW : SVG.FILL.VIEW}>
            <Shape d={theme.NAME === 'LIGHT' ? SVG.OUTLINE.PATH : SVG.FILL.PATH} />
        </IconSVG>
    </RippleButton>
);

/* PropTypes */
Button.propTypes = {
    buttonThemeChange: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withTheme(Button);



// WEBPACK FOOTER //
// ./src/components/NavBar/MX/Component/Buttons/Theme.js